import { render } from "./BackerCenterGiftCardGroup.vue?vue&type=template&id=6ef8b8bb"
import script from "./BackerCenterGiftCardGroup.vue?vue&type=script&lang=js"
export * from "./BackerCenterGiftCardGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__